import React from 'react';
import TextField from '@mui/material/TextField';
import { Controller } from 'react-hook-form';
import {DesktopDatePicker} from "@mui/x-date-pickers/DesktopDatePicker";
import dayjs from "dayjs";

const FormDateField = ({ name, disabled, variant, ...restProps }) => {
  return (
      <Controller
          name={name}
          render={({ field }) => {
            return (
                <>
                  <DesktopDatePicker
                    {...restProps}
                    {...field}
                      size="small"
                      inputProps={{style: {fontSize: 12, width: 80}}}
                      value={field.value || null}
                      onChange={(e)=> {
                        field.onChange(new Date(e));
                      }}
                      renderInput={(params) => <TextField size="small" {...params} />}
                  />
                </>
            )
          }}
      />
  )
};

export default FormDateField;
